import { _isEmpty } from '@/littledash';
import type { FC } from 'react';
import { useMemo } from 'react';
import type { Nullable } from '@/model/Common.model';
import { parseSelectValue } from '@/components/UI/DataTableV2/DataTable.util';
import selectStyles from './MetadataSelectCell.module.scss';

interface DataTableReadonlySelectChipsProps {
  value: Nullable<string>;
  glossaryApiId?: string;
}

/**
 * Renders select/multi-select metadata values as styled chips in readonly cells.
 *
 * Parses select cell values (JSON arrays, primitives, or raw text) and displays each
 * as a styled chip with the same styling as editable MetadataSelectCell for visual consistency.
 */
export const DataTableReadonlySelectChips: FC<DataTableReadonlySelectChipsProps> = ({ value, glossaryApiId }) => {
  const selectDisplayValues = useMemo(() => parseSelectValue(value, glossaryApiId), [value, glossaryApiId]);

  if (_isEmpty(selectDisplayValues)) {
    return <span>&nbsp;</span>;
  }

  return (
    <div className={selectStyles.valuesContainer} data-test-element="select-values-container">
      {selectDisplayValues.map((displayValue, index) => (
        <span key={`${displayValue}-${index}`} className={selectStyles.chip} data-test-element="chip">
          {displayValue}
        </span>
      ))}
    </div>
  );
};
